<template>
  <div style="height: 100%">
    <div class="container-fluid">
      <div class="row p-2 d-flex justify-content-end position-fixed w-100">
        <div class="">
          <base-button
            block
            style="height: 40px;padding:10px 18px; background-color:black; display: flex; align-items: center;"
            native-type="submit"
            type="dark"
            @click="logout"
          >Cerrar sesión
          </base-button>
        </div>
      </div>
    </div>
    <div class="auth-layout-container bg-default d-flex align-items-center justify-content-center">
      <div class="main-content login-app">
        <div class=" container">
          <div class="row justify-content-center">
            <div class="container">
              <div class='row d-flex justify-content-center'>
                <div class='col-sm-12'>
                  <h1 style='color: #b7227e !important' class="d-flex justify-content-center">Hola, es tu primera vez
                    por
                    aquí</h1>
                </div>
                <div class='col-sm-12 mb-2'>
                  <p class="d-flex justify-content-center">Nos podrías compartir la siguiente información completando
                    todos los campos y haciendo clic en Continuar.</p>
                </div>
                <div class='col-sm-10'>
                  <div class="bg-white mt-4 rounded mb-0">
                    <validation-observer
                      ref="formValidator"
                      v-slot="{ handleSubmit }"
                    >
                      <form role="form" @submit.prevent="handleSubmit(onSubmit)">


                        <div class="row">
                          <div class='col-sm-12 col-md-12 col-lg-4'>
                            <md-field class="mb-0">
                              <label class="auth-container__label">Nombre completo</label>
                              <md-input
                                v-model="data.name"
                                alternative

                                name="Name"
                              ></md-input>
                            </md-field>
                            <div v-if="errors.name" class="error-message-register">
                        <span>
                          {{ errors.name }}
                        </span>
                            </div>
                          </div>
                          <div class='col-sm-12 col-md-12 col-lg-4'>
                            <md-field
                              class="mb-0 mt-0 multiselect-register-multiselect"
                            >
                              <multiselect
                                v-model="data.country"
                                :close-on-select="true"
                                :options="getAllCountries"
                                :searchable="true"
                                :show-labels="false"
                                class="details-country shadow__multiselect"
                                label="name"
                                placeholder="Seleccione un País"
                                track-by="id"
                                @input="countryValidation"
                              >
                                <template #option="props">
                                  <div class="option__desc">
                              <span class="option__title">{{
                                  `(${props.option.code}) ${props.option.name}`
                                }}</span>
                                    <span
                                      v-if="
                                  props.values &&
                                  props.values.length &&
                                  !props.values.isOpen
                                "
                                      class="multiselect__single"
                                    >{{ props.values.length }} options
                                selected</span
                                    >
                                  </div>
                                </template>
                                <template #noResult>
                                  <div>Sin resultados</div>
                                </template>
                              </multiselect>
                            </md-field>
                            <div
                              v-if="errors.country"
                              class="error-message-register"
                            >
                              <div v-if="errors.email" class="error-message-register">
                        <span>
                          {{ errors.country }}
                          {{ errors.email }}
                        </span>
                              </div>
                            </div>

                          </div>
                          <div class='col-sm-12 col-md-12 col-lg-4'>
                            <div class="text-center">
                              <base-button
                                :disabled="validateFields"
                                :loading="loading"
                                block
                                class="my-3"
                                style="height: 56px"
                                native-type="submit"
                                type="dark"
                              >Continuar
                              </base-button>
                            </div>
                          </div>
                        </div>
                      </form>
                    </validation-observer>
                  </div>

                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import Multiselect from 'vue-multiselect';
import { AUTH_LOGOUT, AUTH_ONBOARDING } from '@/store/actions/login';

export default {
  name: 'OnBoarding',
  components: {
    Multiselect,
  },

  data () {
    return {
      data: {
        name: '',
        country: '',
      },
      loading: false,
      errors: {
        name: '',
        country: '',
      },
    };
  },
  computed: {
    ...mapGetters(['getAllCountries', 'getProfile']),
    validateFields: function() {
      return !(this.data.name && this.data.country);
    },
  },
  mounted () {
    console.log(this.getProfile)
  },
  methods: {
    logout() {
      this.$store.dispatch(AUTH_LOGOUT, this.getProfile.id).then(() => {
        window.location.href = '/';
      });
    },
    countryValidation () {
      if (!this.data.country) {
        this.errors.country = 'El país es requerido';
      }
    },
    onSubmit () {
      const { name } = this.data;
      const id = this.getProfile.id;
      const country_id = this.data.country.id;
      this.loading = true;
      this.$store
        .dispatch(AUTH_ONBOARDING, {
          id,
          name, country_id,
        })
        .then(() => {
          this.loading = false;
          window.location.reload();
        })

        .catch((error) => {
          this.loading = false;
          this.notify(error, 'danger');
        });
    },
    notify (message, type) {
      this.$notify({
        type: type,
        verticalAlign: 'top',
        horizontalAlign: 'right',
        message: message,
      });
    },
  },
};
</script>
<style scoped>
.course-url-col {
  display: flex;
  align-items: center;
  flex-direction: row;
}

.course-slug {
  margin: 0 0 0 10px;
}

.course-slug .form-group {
  margin: 0;
}

.course-image {
  width: auto;
  height: auto;
  object-fit: cover;
}

.course-image-container {
  padding: 15px 20px;
  width: 100%;
}

.course-image-container > img {
  width: 100%;
}

.custom-radio .custom-control-input ~ .custom-control-label {
  padding-top: 1px;
}

.ql-container {
  height: 40vh;
}

.ql-toolbar.ql-snow + .ql-container.ql-snow {
  border-bottom-left-radius: 3px;
  border-bottom-right-radius: 3px;
}

.ql-editor:hover {
  box-shadow: none;
}

.col-md-9 .form-group input,
.input-usd {
  padding: 6px;
  padding-left: 12px !important;
  width: 100% !important;
}

.custom-file-label::after {
  background-color: #b7227e !important;
  color: white !important;
  border: 1px solid #b7227e !important;
  border-radius: 0 !important;
}

.base-radio {
  color: #000;
}

.style-text-config {
  font-size: 15px;
  color: #000;
  font-weight: 700;
  text-transform: uppercase;
  margin-bottom: 1rem;
}

.ql-editor {
  box-shadow: none !important;
  border-top: 1px solid #dee2e6;
}

.custom-radio .custom-control-input:checked ~ .custom-control-label::after,
.custom-radio .custom-control-input:checked ~ .custom-control-label::before {
  background: #000;
  border-radius: 50%;
}

.dropdwon-icon {
  margin-top: -34px;
}

.dropdwon-icon i {
  padding: 6px;
  background: white;
  margin-right: -5px;
}

.select-config .multiselect__select:before,
.multiselect__select:before {
  border: none;
  font-size: 16px !important;
}

.select-config .multiselect__select {
  transition: none;
  transform: scale(1);
}

.multiselect__tag {
  line-height: 20px !important;
  background-color: #b7227e;
  margin-top: 5px;
}

.multiselect__tag .multiselect__tag-icon:after {
  color: white;
}

.multiselect__tag .multiselect__tag-icon:hover {
  color: white;
  background-color: #b7227e;
}

.main-container__librery input.multiselect__input {
  padding-left: 0px;
  border: none !important;
}

.alert-notify {
  display: -webkit-box !important;
  display: -ms-flexbox !important;
  display: flex !important;
  max-width: 600px;
  width: calc(100% - 30px);
  padding-right: 80px;
  color: rgba(255, 255, 255, 0.85);
}

.name-course-input input {
  width: 100% !important;
  padding-left: 10px !important;
}

.loading-course-detail {
  color: black;
}

.multiselect__option--highlight {
  background: black;
  outline: none;
  color: #fff;
}

.multiselect__option--highlight::after {
  background: black;
  outline: none;
  color: #000;
}

.select-status {
  height: 52px;
}

.multiselect--active .multiselect__select {
  -webkit-transform: none;
  transform: none;
}

.multiselect__select::before {
  top: 35%;
}

.multiselect__single {
  padding: 0px !important;
  margin-top: 10px !important;
  margin-bottom: 10px !important;
  line-height: 30px;
  font-size: 16px;
  letter-spacing: 0.01em;
}

.multiselect__placeholder {
  padding-top: 0px !important;
  margin-top: 10px;
  margin-bottom: 10px;
  line-height: 30px;
  font-size: 16px;
  letter-spacing: 0.01em;
}

.multiselect__tags {
  height: 52px;
  padding: 0px 40px 0px 13px !important;
  display: flex;
}

.multiselect__input,
.multiselect__tag {
  margin-top: 10px !important;
  margin-bottom: 10px !important;
  line-height: 20px !important;
}

.multiselect__input {
  padding: 0px !important;
  margin-top: 10px !important;
  margin-bottom: 10px !important;
  font-size: 16px;
  letter-spacing: 0.01em;
  line-height: 30px;
}

.multiselect__select {
  height: 50px;
  width: 50px;
  margin-top: 0px !important;
  padding: 0px !important;
}

.main-container__librery input {
  background-color: #fff;
  border-radius: 3px;
}

.select-status {
  padding: 0px 10px 0px 10px !important;
  font-size: 16px !important;
}

.details-select {
  height: 30px !important;
  width: 40px !important;
  padding: 0px !important;
  margin-top: 10px !important;
  position: absolute;
  top: 50%;
  right: 0%;
  transform: translate(-50%, -50%);
  background: white;
  padding: 10px;
  font-size: 14px;
  text-align: center;
}

.fa-chevron-down:before {
  margin-top: 15px;
  font-size: 16px;
  margin-right: 5px;
}

.multiselect__select::before {
  top: 35% !important;
}

.main-container__librery .border-name input {
  border: 1px solid #ddd !important;
}

.multiselect__tag .multiselect__tag-icon:after {
  -ms-flex-line-pack: center;
  align-content: center;
  position: absolute;
  top: 10%;
  right: 30%;
}

.multiselect__content-wrapper {
  top: 100% !important;
  bottom: auto !important;
}

.multiselect__option--selected {
  background: #b5016d !important;
  color: #fff !important;
  font-weight: 500 !important;
}

.multiselect--above .multiselect__content-wrapper {
  top: 100% !important;
  bottom: auto !important;
}

.option_trailer_video {
  display: flex !important;
}

.option__image {
  height: 50px !important;
}

.option__title {
  padding-left: 10px;

}

.option__desc {
  padding: 5px 0;
}

.multiselect__option {
  display: flex;
}

.multiselect__option.multiselect__option--highlight::after {
  background-color: transparent !important;
}
</style>

<style scoped>
.forgotpassword {
  font-size: 12px;
}

.auth-layout-container {
  background: #000;
}

.auth-layout-container .md-field .md-input,
.auth-layout-container .md-field .md-textarea,
.auth-layout-container .select-country {
  box-shadow: none !important;
}

.auth-layout-container .md-field .md-input,
.auth-layout-container .md-field .md-textarea,
.auth-layout-container .border-color {
  border: 1px solid #d4d4d4 !important;
}

.md-field .md-input,
.md-field .md-input:focus,
.md-field .md-textarea,
.md-field .md-textarea:focus,
.border-color {
  border: 1px solid #d4d4d4 !important;
}


.multiselect__option .multiselect__option--highlight > div > span {
  color: #fff !important;
}

.md-field {
  margin: 0 !important;
}

.multiselect__option--selected {
  background: #b7227e !important;
  color: #ffffff !important;
  font-weight: 500 !important;
}

.multiselect__option--selected span {
  color: #fff !important;
}


</style>
